import { useRouter } from "next/router";
import { useCallback } from "react";

import { Log } from "@accurx/shared";

import { useIdleTimerSetup } from "../../../utils/IdleTimer/IdleTimer";
import { useCreatePatientInitiatedPath } from "../constant/paths";
import { useOrganisation } from "../context/OrganisationContext";
import { useNhsApp } from ".";

export const IDLE_TIMEOUT = 630000; // 10mins 30secs

export const useIdleTimer = (): void => {
    const isUsingNhsApp = useNhsApp();
    const router = useRouter();
    const createPatientInitiatedPath = useCreatePatientInitiatedPath();
    const { organisationSettings } = useOrganisation();

    const refreshPageOnTimeout = useCallback(() => {
        Log.info("Redirecting back to homepage", {
            tags: {
                anonymousRequestId: organisationSettings?.requestTrackingId,
                isNhsApp: isUsingNhsApp,
            },
        });

        if (isUsingNhsApp && window.nhsapp?.navigation) {
            window.nhsapp.navigation.goToHomepage();
            return;
        }
        const patientInitiatedLandingPagePath = createPatientInitiatedPath({
            path: "",
        });
        if (router.asPath === patientInitiatedLandingPagePath) {
            void router.reload();
            return;
        }
        void router.push(patientInitiatedLandingPagePath);
        // Adding createPatientInitiatedPath to dependencies creates an update loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUsingNhsApp, router]);

    useIdleTimerSetup({ onIdle: refreshPageOnTimeout, timeout: IDLE_TIMEOUT });
};
